import { useState } from 'react';

/**
 * Interruptor claro/oscuro.
 *
 * Guarda la elección en `localStorage`: el usuario decide, y el sistema no le
 * quita el tema cuando vuelve. `aria-label` cambia con el estado para que un
 * lector de pantalla sepa qué va a pasar al pulsarlo.
 */
export function TemaToggle() {
  const [tema, setTema] = useState(() =>
    document.documentElement.classList.contains('dark') ? 'dark' : 'light',
  );

  const alternar = () => {
    const nuevo = tema === 'dark' ? 'light' : 'dark';
    document.documentElement.classList.toggle('dark', nuevo === 'dark');
    localStorage.setItem('academy-tema', nuevo);
    setTema(nuevo);
  };

  const oscuro = tema === 'dark';
  const etiqueta = oscuro ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro';

  return (
    <button
      type="button"
      onClick={alternar}
      aria-label={etiqueta}
      title={etiqueta}
      className="inline-flex size-9 items-center justify-center rounded-lg text-ink-500 ring-1 ring-inset ring-ink-200 transition-colors hover:bg-ink-50 hover:text-brand-700"
    >
      {oscuro ? (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
          <path
            d="M12 2v2m0 16v2M4.93 4.93l1.41 1.41m11.32 11.32 1.41 1.41M2 12h2m16 0h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      ) : (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M21 12.79A9 9 0 1 1 11.21 3a7 7 0 0 0 9.79 9.79z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </button>
  );
}